const RequiredBox = () => {
    return (
      <div className="text-[9px] font-[500] leading-[100%] text-white rounded-[5px] py-[3px] pl-[6.5px] pr-[5.5px] bg-danger">
        必須
      </div>
    );
  };
  
  export default RequiredBox;
  